/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AppointmentExchangeOfferStatus = {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    Withdrawn: 'Withdrawn'
} as const;
export type AppointmentExchangeOfferStatus = typeof AppointmentExchangeOfferStatus[keyof typeof AppointmentExchangeOfferStatus];


export function instanceOfAppointmentExchangeOfferStatus(value: any): boolean {
    for (const key in AppointmentExchangeOfferStatus) {
        if (Object.prototype.hasOwnProperty.call(AppointmentExchangeOfferStatus, key)) {
            if (AppointmentExchangeOfferStatus[key as keyof typeof AppointmentExchangeOfferStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AppointmentExchangeOfferStatusFromJSON(json: any): AppointmentExchangeOfferStatus {
    return AppointmentExchangeOfferStatusFromJSONTyped(json, false);
}

export function AppointmentExchangeOfferStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentExchangeOfferStatus {
    return json as AppointmentExchangeOfferStatus;
}

export function AppointmentExchangeOfferStatusToJSON(value?: AppointmentExchangeOfferStatus | null): any {
    return value as any;
}

export function AppointmentExchangeOfferStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AppointmentExchangeOfferStatus {
    return value as AppointmentExchangeOfferStatus;
}

